module.exports = __webpack_public_path__ + "img/konfir.5aa524f7.svg";